import { lazy, type ComponentType } from 'react';

export type Priority = 'P0' | 'P1' | 'P2';

export interface ChapterEntry {
  id: string;
  num: string;
  prio: Priority;
  load: () => Promise<{ default: ComponentType<{ t: (k: string) => string }> }>;
  Component: ComponentType<{ t: (k: string) => string }>;
}

const lazyChapter = (loader: () => Promise<{ default: ComponentType<{ t: (k: string) => string }> }>) =>
  lazy(loader);

export const CHAPTERS: ChapterEntry[] = [
  { id: 'ch01', num: '01', prio: 'P0', load: () => import('./Ch01MatrixViews'), Component: lazyChapter(() => import('./Ch01MatrixViews')) },
  { id: 'ch02', num: '02', prio: 'P0', load: () => import('./Ch02VectorProduct'), Component: lazyChapter(() => import('./Ch02VectorProduct')) },
  { id: 'ch03', num: '03', prio: 'P0', load: () => import('./Ch03MatrixVector'), Component: lazyChapter(() => import('./Ch03MatrixVector')) },
  { id: 'ch04', num: '04', prio: 'P1', load: () => import('./Ch04Subspaces'), Component: lazyChapter(() => import('./Ch04Subspaces')) },
  { id: 'ch05', num: '05', prio: 'P1', load: () => import('./Ch05MatrixProduct'), Component: lazyChapter(() => import('./Ch05MatrixProduct')) },
  { id: 'ch06', num: '06', prio: 'P2', load: () => import('./Ch06Patterns'), Component: lazyChapter(() => import('./Ch06Patterns')) },
  { id: 'ch07', num: '07', prio: 'P1', load: () => import('./Ch07CR'), Component: lazyChapter(() => import('./Ch07CR')) },
  { id: 'ch08', num: '08', prio: 'P1', load: () => import('./Ch08LU'), Component: lazyChapter(() => import('./Ch08LU')) },
  { id: 'ch09', num: '09', prio: 'P1', load: () => import('./Ch09QR'), Component: lazyChapter(() => import('./Ch09QR')) },
  { id: 'ch10', num: '10', prio: 'P0', load: () => import('./Ch10EVD'), Component: lazyChapter(() => import('./Ch10EVD')) },
  { id: 'ch11', num: '11', prio: 'P0', load: () => import('./Ch11SVD'), Component: lazyChapter(() => import('./Ch11SVD')) },
  { id: 'ch12', num: '12', prio: 'P1', load: () => import('./Ch12FiveFactorizations'), Component: lazyChapter(() => import('./Ch12FiveFactorizations')) },
  { id: 'ch13', num: '13', prio: 'P1', load: () => import('./Ch13EigenvalueMap'), Component: lazyChapter(() => import('./Ch13EigenvalueMap')) },
  { id: 'ch14', num: '14', prio: 'P1', load: () => import('./Ch14MatrixWorld'), Component: lazyChapter(() => import('./Ch14MatrixWorld')) },
  { id: 'ch15', num: '15', prio: 'P1', load: () => import('./Ch15AxbSubspaces'), Component: lazyChapter(() => import('./Ch15AxbSubspaces')) },
  { id: 'ch16', num: '16', prio: 'P1', load: () => import('./Ch16PatternsAtlas'), Component: lazyChapter(() => import('./Ch16PatternsAtlas')) },
];

export const findChapter = (id: string): ChapterEntry | undefined =>
  CHAPTERS.find((c) => c.id === id);
